// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApplyForLoan_applyScreen__aic5S {
  border-radius: 20.188px;
  box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);
  background-color: var(--Primary, #e7ecef);
  display: flex;
  flex-direction: column;
  min-width: 100%;
  min-height: 100%;
}

.ApplyForLoan_applyContainer__dUaGT {
  align-self: center;
  margin-top: 26px;
  margin-bottom: 108px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
}

.ApplyForLoan_applyContent__JahEe {
  gap: 20px;
  display: flex;
  min-height: 100%;
  justify-content: flex-start;
}

.ApplyForLoan_applyDashboardContainer__AIVef {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 81%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
}

  
  .ApplyForLoan_applyDashboardContent__Y-ias {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    width: 700px;
    margin-left: 10%;
    @media (max-width: 991px) {
      max-width: 100%;
      margin-top: 20px;
    }
  }
  

  .ApplyForLoan_applyCard__heFAW{
    border-radius: 16.842px;
    box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
    align-self: stretch;
    display: flex;
    margin-top: 30px;
    flex-grow: 1;
    flex-direction: column;
    @media (max-width: 991px) {
    maxWidth: 100%;
        marginRight: 2px
    };
    padding: 47px 20px 145px;
  }

  .ApplyForLoan_chooseAProduct__w3s7c{
    color: #000;
    font-family: Roboto, sans-serif;
    font-size: 40px;
    font-weight: 400;
    align-self: center;
    margin-left: -26 px;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        text-wrap: initial;
    }
  }

  .ApplyForLoan_applyCardContainer__JkPYV{
    align-self: center;
    width: 680px;
    max-width: 100%;
    @media (max-width: 991px) {
        margin: "40px 0 10px",
    };
    margin: 43px 0 -29px;
  }

  .ApplyForLoan_applyCardContent__HvfY7{
    gap: 20 px;
    display: flex;
    @media (max-width: 991px) {
        flex-direction: column;
        align-items: stretch;
        gap: 0px
    }
  }

  .ApplyForLoan_cardContent__tEsY-{
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 43%;
    margin-left: 0px;
    @media (max-width: 991px) {
        width: 100%;
        margin-left: 0;
    }
  }

  .ApplyForLoan_purchaseButton__mbULy{
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    border: none;
    background-color: var(--boxes, #F8F8FB);
    @media (max-width: 991px) {
        margin-top: 40 px;
    }
  }

  .ApplyForLoan_imgClass__esTlm{
    aspect-ratio: 1.42;
    object-fit: cover;
    object-position: center;
    width: 220px;
    overflow: hidden;
    align-self: stretch;
    justify-content: center;
    margin-left: auto;
  }

  .ApplyForLoan_purchase__nC1\\+a{
    color: #000;
    font-family: Roboto, sans-serif;
    font-size: 40px;
    font-weight: 400;
    align-self: center;
    margin-left: 14 px;
    text-wrap: nowrap;
    margin-left: 100px;
    @media (max-width: 991px) {
        text-wrap: initial;
    }
  }

  .ApplyForLoan_loanOfficer__7x0Wp {
    display: flex;
    flex-direction: column;
    line-height: normal;
    height: 20%;
    width: 25%;
    margin-left: -25%;
    @media (max-width: 991px) {
    marginLeft: 0,
    }
}

.ApplyForLoan_loanOfficerCard__yTwRZ {
    border-radius: 16.842px;
    box-shadow:
        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
    display: flex;
    flex-grow: 1;
    width: 214px;
    max-width: 50%;
    flex-direction: column;
    width: 100%;
    margin: auto;
    overflow: scroll;
    @media (max-width: 991px) {
        marginTop: 20px;
    };
    margin: auto;
    padding: 22px 20px 69px
}

.ApplyForLoan_loanOfficerCardContent__KB1w4 {
    align-self: center;
    display: flex;
    margin-left: -19px;
    margin-bottom: 8px;
    width: 256px;
    max-width: 100%;
    flex-direction: column;
}

.ApplyForLoan_loanOfficerImg__vHk20{
    aspect-ratio: 1.05;
    object-fit: cover;
    object-position: center;
    width: 138 px;
    overflow: hidden;
    border-radius: 50%;
    align-self: center;
    max-width: 100%;
}

.ApplyForLoan_homeImg__5lZE0{
    aspect-ratio: 1.05;
    object-fit: cover;
    object-position: center;
    width: 138 px;
    overflow: hidden;
    border-radius: 50%;
    align-self: center;
    max-width: 100%;
}

.ApplyForLoan_yourLoanOfficer__HrUrX {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 32px;
    font-weight: 700;
    align-self: start;
    margin-top: 9px
}

.ApplyForLoan_loanOfficerInfo__022yZ {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 25px;
    font-weight: 700;
    align-self: start;
    margin-top: 9px
}

.ApplyForLoan_forgotPasswordLink__ZVzgX {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 25px;
    font-weight: 700;
    align-self: start;
    margin-top: 25px
}


.ApplyForLoan_yourLoanOfficer__HrUrX {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 20.122px;
    font-weight: 700;
    align-self: center;
    margin-top: 5px;
    text-wrap: nowrap;
}

.ApplyForLoan_loanOfficerInfo__022yZ {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 13.5px;
    font-weight: 600;
    align-self: start;
    margin-left: 30px;
    margin-top: 13px 0 100px -10px;
    overflow: scroll;
}

.ApplyForLoan_borrowerFormTitle__Qn0Se {
  color: #000;
  align-self: start;
  flex-grow: 1;
  flex-basis: auto;
  font: 400 30px Roboto, sans-serif ;
  text-align: center;
  margin-bottom: 10px;
}

.ApplyForLoan_coborrower__sOlg- {
  color: #3E94A3;
  font-feature-settings: clig off, liga off;
  letter-spacing: -0.408px;
  text-align: left;
  align-self: start;
  margin-top: 10px;
  text-wrap: nowrap;
  font: 600 16px/137.5% Poppins, sans-serif;
  @media (max-width: 991px) {
    textWrap: "initial",
  };
}

.ApplyForLoan_borrowerFormCard__RiaAy {
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
  align-self: center;
  display: flex;
  width: 707px;
  height: 448px;
  max-width: 100%;
  flex-direction: column;
  text-align: center;
  padding: 13px 8px 13px 20px;
  @media (max-width: 991px) {
    marginBottom: "40px",
  };
}


.ApplyForLoan_borrowerFormCardTabs__q2hDb {
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #F8F8FB);
  align-self: center;
  display: flex;
  width: 707px;
  height: 448px;
  max-width: 100%;
  flex-direction: column;
  text-align: center;
  margin-top: -20px;
  padding: 13px 8px 13px 20px;
  overflow: scroll;
  @media (max-width: 991px) {
    margin-bottom: "40px",
  };
}

.ApplyForLoan_borrowerFormCardTabsInvisible__N9OjV {
  display: none;
  visibility: hidden;
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
  align-self: center;
  width: 707px;
  height: 448px;
  max-width: 100%;
  flex-direction: column;
  text-align: center;
  margin-top: -20px;
  padding: 13px 8px 13px 20px;
  overflow: scroll;
  @media (max-width: 991px) {
    marginBottom: "40px",
  };
}

.ApplyForLoan_borrowerFormCardDiv__6rT6u{
  align-self: center;
  display: flex;
  width: 707px;
  height: 100%;
  max-width: 95%;
  flex-direction: column;
  text-align: center;
  overflow: scroll;
  @media (max-width: 991px) {
    margin-bottom: "40px",
  };
}

.ApplyForLoan_formContainer__\\+Qhfu {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 700px;
  margin-left: 70px;
  margin-right: 50px;
}

.ApplyForLoan_inputsContainer__8UugC{
  align-self: start;
  display: flex;
  width: 635px;
  max-width: 100;
  align-items: flex-start;
  gap: 13px;
  @media (max-width: 991px) {
    flexWrap: "wrap",
  };
}

.ApplyForLoan_declarationsDiv__h1SzK{
  width: 300px;
  margin-left: 5px;
  margin-right: auto;
  text-align: left;
}

.ApplyForLoan_signInInput__WLaOu {
  padding: 10px;
  font-size: 12px;
  border-width: 1px;
  border-color: hsl(0, 0%, 64%);
  background-color: #ffffff;
  color: #a6a6a6;
  border-style: solid;
  border-radius: 35px;
  display: flex;
  width: 100%;
  height: 15px;
  padding-left: 20px;
  padding-right: 60px;
}

.ApplyForLoan_formInput__eTovx {
  padding: 10px;
  font-size: 12px;
  border-width: 1px;
  border-color: #b1b1b1;
  background-color: #ffffff;
  color: #000000;
  border-style: solid;
  border-radius: 35px;
  display: flex;
  width: 100%;
  height: 15px;
  padding-left: 20px;
  padding-right: 60px;
}

.ApplyForLoan_formInputEthnicity__AtE2K {
  padding: 10px;
  font-size: 12px;
  border-width: 1px;
  border-color: #b1b1b1;
  background-color: #ffffff;
  color: #000000;
  border-style: solid;
  border-radius: 35px;
  display: flex;
  width: 100%;
  height: 5px;
  padding-left: 20px;
  padding-right: 60px;
}

.ApplyForLoan_inputDiv__vgHUN {
  width: 300px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
}

.ApplyForLoan_inputDivEthnicity__w\\+ywx {
  width: 130px;
  margin-top: 5;
  margin-bottom: 5;
  margin-left: 25px;
  display: flex;
}

.ApplyForLoan_yearsAtAddressDiv__cudQI{
  width: 300px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
}

.ApplyForLoan_ownerRadioButtons__ZoknH {
  margin-top: 10px;
  margin-left: 10px;
  display: inline-block;
  text-align: left;
}

.ApplyForLoan_title__Vwz\\+X {
  text-align: center;
}

.ApplyForLoan_borrowerFormCardTitleText__-kMxt {
  align-self: end;
  width: 603px;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  gap: 20px;
 
}

.ApplyForLoan_coborrowerRadioContainer__K04gF {
  color: #000;
  font-feature-settings: clig off liga off;
  align-self: end;
  margin-left: 10px;
  text-wrap: nowrap;
  text-align: left;
  @media (max-width: 991px) {
    textWrap: "initial";
  };
  font: 400 16px/137.5% Poppins, sans-serif;
}

.ApplyForLoan_coborrowerRadioHispanic__bcZ4K {
  color: #000;
  font-feature-settings: clig off liga off;
  align-self: end;
  margin-left: 30px;
  text-wrap: nowrap;
  text-align: left;
  font-size: 10px;
  @media (max-width: 991px) {
    textWrap: "initial";
  };
  font: 400 16px/137.5% Poppins, sans-serif;
}

.ApplyForLoan_coborrowerRadio__Lr9UN label{
  opacity: .4;
}

.ApplyForLoan_coborrowerRadio__Lr9UN input[type=radio]{
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: .9em;
  height: .9em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  border-color: #3E94A3;
  margin-right: 5px;
  transform: translateY(0.075em);
  margin-left: 10px;
}

.ApplyForLoan_coborrowerRadio__Lr9UN input[type=radio]:checked{
  background-color: #3E94A3;
}

.ApplyForLoan_nextButtonDiv__-kIxw{
  margin-left: auto;
  margin-right: 5 px;
}

.ApplyForLoan_nextButtonWithRadiosDiv__6EDPh{
  display: flex;
  margin-left: 15px;
  margin-top: 10px;
}

.ApplyForLoan_addressRadio__ZK3Kw{
  margin-right: 10px;
}

.ApplyForLoan_nextButton__Cm8\\+Q{
  background-color: #3E94A3;
  font-size: 16px;
  width: 100px;
  height: 35px;
  border-radius: 17px;
  font-weight: 300;
  color: #ffffff;
  border-color: #3E94A3;
  margin-top: 20px;
  margin-right: 10px;
  margin-bottom: 3.5px;
  border-style: none;
}

.ApplyForLoan_newIncomeButton__18aMA{
  background-color: #3E94A3;
  font-size: 16px;
  width: 300px;
  height: 35px;
  border-radius: 17px;
  font-weight: 300;
  color: #ffffff;
  border-color: #3E94A3;
  margin-top: 20px;
  margin-right: 10px;
  margin-bottom: 3.5px;
  border-style: none;
}

.ApplyForLoan_backButton__oFSIl{
  background-color: #ffffff;
  font-size: 16px;
  color: #3E94A3;
  width: 100px;
  height: 35px;
  border-radius: 17px;
  font-weight: 300;
  cursor: pointer;
  margin-top: 20px;
  margin-right: 10px;
  margin-bottom: 3.5px;
  border-color: #3E94A3;
}

.ApplyForLoan_myLoanerContainer__lq0b\\+ {
  display: flex;
  flex-direction: column;
  width: 20px;
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
  align-self: center;
  display: flex;
  width: 350px;
  height: 570px;
  max-width: 100%;
  text-align: center;
  margin-right: 10px;
  margin-top: -20px;
}

.ApplyForLoan_myLoanerContent__YKo7N {
  display: flex;
  margin-top: 10px;
  flex-direction: column;
  align-self: center;
  width: 230px;
  font-size: 24px;
  justify-content: center;
}

.ApplyForLoan_rectangle__PtKAH {
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #F8F8FB);
  align-self: center;
  display: flex;
  margin-bottom: 59px;
  width: 730px;
  height: 35px;
  flex-direction: column;
  @media (max-width: 991px) {
    maxWidth: "100%";
    marginTop: "40px"
  }
}

.ApplyForLoan_rectangleTabs__4Zb8r {
  border-radius: 16.842px;
  box-shadow:
    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #F8F8FB);
  align-self: center;
  display: flex;
  width: 730px;
  height: 35px;
  margin-bottom: 10px;
  flex-direction: column;
  @media (max-width: 991px) {
    maxWidth: "100%";
    marginTop: "40px"
  }
}

.ApplyForLoan_coborrowerLink__wKcjK {
  justify-content: left;
  color: var(--half-secondary, #3E94A3);
  font-family:
      Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  align-self: start;
  margin-top: 25px;
  text-decoration: none;
}

.ApplyForLoan_addressRadioButtons__MYBni{
  margin-top: 20px;
  display: inline-block;
  text-align: left;
}

.ApplyForLoan_borrowerPresentAddressDiv__FyajV{
  margin-top: 20px;
  margin-bottom: 20px;
}

.ApplyForLoan_useAddressDiv__SAi7z{
  margin-top: 0px;
  margin-bottom: 20px;
}

.ApplyForLoan_dropdown__0xzk0 {
  padding: 10px;
  font-size: 18px;
  border-width: 1px;
  border-color: #b1b1b1;
  background-color: #ffffff;
  color: #b1b1b1;
  border-style: solid;
  border-radius: 35px;
  display: flex;
  width: 100%;
  height: 15px;
  padding-left: 20px;
  padding-right: 60px;
}

.ApplyForLoan_selectBox__S40-V{
  width:100%;
  height:100%;
  border:0px;
  outline:none;
  color: #656565;
}

.ApplyForLoan_label__K\\+i1n {
  color: #000;
  opacity: 40%;
  text-align: left;
  margin-left: 5px;
  font-size: 15px;
  margin-top: 10px;
}

.ApplyForLoan_labelEthnicity__gUUhv {
  color: #000;
  opacity: 40%;
  text-align: left;
  margin-left: 5px;
  font-size: 15px;
}

.ApplyForLoan_jobLabel__HD8\\+r{
  color: #000;
  opacity: 40%;
  text-align: left;
  margin-left: 5px;
  font-size: 15px;
}

.ApplyForLoan_govtWarningDiv__BDXgq{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: #656565;
  margin-top: 75px;
  margin-bottom: 93px;
  font-size: 17px;
}

.ApplyForLoan_creditScoreTextLabel__UyAKU {
  width: 290px;
  margin-top: 5px;
  margin-left: -5px;
  margin-left: 5px;
  display: flex;
}

.ApplyForLoan_zipCodeDiv__p6XmR{
  display: flex;
}

.ApplyForLoan_imgLogo__mL71x {
  aspect-ratio: 3.82;
  object-fit: contain;
  object-position: center;
  width: 149px;
  overflow: hidden;
  align-self: start;
  margin-top: 5px;
  max-width: 100%;
}

.ApplyForLoan_welcomeMessageDiv__J3Ks2 {
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.8;
  align-self: start;
  margin-top: 22px;
  white-space: nowrap;
  font: 600 16px/137.5% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
}

.ApplyForLoan_miniCard__RdLq6 {
  border-radius: 16.842px;
  box-shadow:
      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #ffffff);
  display: flex;
  flex-grow: 1;
  width: 300px;
  max-height: 30%;
  flex-direction: column;
  margin: auto;
  overflow: scroll;
  @media (max-width: 991px) {
      marginTop: 20px;
  };
  margin: auto;
  padding: 22px 20px 69px
}

.ApplyForLoan_miniCardTitle__86bai {
  position: relative;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.8;
  align-self: start;
  white-space: nowrap;
  font: 500 15px/169% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
}

.ApplyForLoan_miniCardText__Wc9jH {
  position: relative;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.6;
  align-self: start;
  margin-top: 14px;
  font: 400 13px/164% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
    text-align: left;
}

.ApplyForLoan_miniCardRadio__wDBQm {
  color: #000;
  font-feature-settings: clig off liga off;
  margin-top: 10px;
  text-wrap: nowrap;
  text-align: left;
  @media (max-width: 991px) {
    textWrap: "initial";
  };
  font: 400 16px/137.5% Poppins, sans-serif;
}

.ApplyForLoan_miniCardRadio__wDBQm input[type=radio]{
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: .9em;
  height: .9em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  border-color: #3E94A3;
  margin-right: 5px;
  transform: translateY(0.075em);
  margin-left: 10px;
}

.ApplyForLoan_miniCardRadio__wDBQm input[type=radio]:checked{
  background-color: #3E94A3;
}

.ApplyForLoan_carButtonDiv__V4fOB{
  margin-left: auto;
  margin-right: auto;
}

.ApplyForLoan_cardButtonWithRadiosDiv__OcEpL{
  display: flex;
  margin-left: 15px;
  margin-top: 10px;
}

.ApplyForLoan_cardButton__US\\+zk{
  background-color: #3E94A3;
  font-size: 16px;
  width: 300px;
  height: 35px;
  border-radius: 17px;
  font-weight: 900;
  color: #ffffff;
  border-color: #3E94A3;
  margin-bottom: 10px;
  border-style: none;
}

.ApplyForLoan_miniCardContainer__YIG2k{
  align-self: start;
  display: flex;
  width: 635px;
  align-items: flex-start;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  gap: 20px;
  @media (max-width: 991px) {
    flexWrap: "wrap",
  };
}

.ApplyForLoan_miniCardTextDiv__kbp\\+y{
  align-self: start;
  display: flex;
  width: 315px;
}

.ApplyForLoan_infoCardTitle__SMJu9{
  text-align: left;
  position: relative;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.8;
  align-self: start;
  white-space: nowrap;
  font: 500 16px/169% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
  margin-bottom: -10px;
}

.ApplyForLoan_infoCardTextLabel__qETU6{
  text-align: left;
  position: relative;
  color: #000000a7;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.8;
  align-self: start;
  white-space: nowrap;
  font: 300 13px/169% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
}

.ApplyForLoan_infoCardText__631UX{
  text-align: left;
  position: relative;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  opacity: 0.8;
  align-self: start;
  max-width: 100px;
  white-space: nowrap;
  font: 300 13px/169% Poppins, -apple-system, Roboto, Helvetica,
    sans-serif;
}

.ApplyForLoan_infoCardTextDiv__aa2WP {
  width: 300px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
}

.ApplyForLoan_miniCardContainerSplit__M9v8X{
  align-self: start;
  display: flex;
  width: 265px;
  max-width: 100;
  margin-bottom: -15px;
  align-items: flex-start;
  gap: 13px;
  @media (max-width: 991px) {
    flexWrap: "wrap",
  };
}

.ApplyForLoan_inputDivMiniCard__Zjx3c {
  width: 200px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
}

.ApplyForLoan_inputsContainerMiniCard__mfsbl{
  align-self: start;
  display: flex;
  width: 250px;
  max-width: 100;
  align-items: flex-start;
  gap: 13px;
  @media (max-width: 991px) {
    flexWrap: "wrap",
  };
}

.ApplyForLoan_inputsDivMiniCard__qlbY0 {
  width: 300px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
}

.ApplyForLoan_tabs__t04AZ li { 
  /* Makes a horizontal row */
  float: right; 
  list-style-type: none;
  
  /* So the psueudo elements can be
     abs. positioned inside */
}
.ApplyForLoan_tabs__t04AZ button { 
  /* Make them block level
     and only as wide as they need */
  float: left; 
  padding: 10px 40px; 
  text-decoration: none;
  font-size: 15px;

  width: 170px;
  
  /* Default colors */ 
  color: #fff;
  background: #3E94A3;
  /* Only round the top corners */
  -webkit-border-top-left-radius: 15px;
  -webkit-border-top-right-radius: 15px;
  -moz-border-radius-topleft: 15px;
  -moz-border-radius-topright: 15px;
  border-top-left-radius: 10px;
  border-top-right-radius: 15px; 
  border: none;
}
.ApplyForLoan_tabs__t04AZ .ApplyForLoan_active__doMEZ {
  /* Highest, active tab is on top */
  z-index: 3;
}
.ApplyForLoan_tabs__t04AZ .ApplyForLoan_active__doMEZ button { 
  /* Colors when tab is active */
  background-color: #fbfbfb; 
  color: black; 
}

.ApplyForLoan_errorDiv__jXBaR{
  color: #3E94A3;
  font-size: 15px;
  margin-left: 10px;
  margin-bottom: -16px;
  margin-top: -1.5px;
}

.ApplyForLoan_errorAndInputDiv__YRI6R{
  text-align: left;
}

.ApplyForLoan_uldiv__ezReL {
  align-items: center;
}

.ApplyForLoan_uldiv__ezReL li {
  width: 525px;
  height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1em;
  background: #3E94A3;
  position: relative;
  color: white;
  border-radius: 5px;
  margin-bottom: 10px;
}

.ApplyForLoan_removeButton__nDsuj{
  background-color: #ffffff;
  font-size: 16px;
  color: #3E94A3;
  width: 75px;
  height: 35px;
  border-radius: 17px;
  font-weight: 300;
  cursor: pointer;
  border-color: #3E94A3;
  margin-left: auto;
  margin-right: 5px;
  border-style: none;
}

.ApplyForLoan_incomeTypeText__AgQxR{
  font-weight: 700;
}

.ApplyForLoan_blankSpaceConfirmInfo__Mdp9G li{
  list-style: none;
}
.ApplyForLoan_blankSpaceConfirmInfo__Mdp9G {
  text-align: left;
}

.ApplyForLoan_blankSpaceConfirmInfo__Mdp9G h2{
  font: 300 20px Roboto, sans-serif ;
}`, "",{"version":3,"sources":["webpack://./src/components/ApplyForLoan.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;IACE,WAAW;IACX,cAAc;EAChB;AACF;;;EAGE;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;;EAGA;IACE,uBAAuB;IACvB;gEAC4D;IAC5D,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB;IACA,cAAc;QACV;IACJ;IACA,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB;QACI,kBAAkB;IACtB;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf;QACI;IACJ;IACA,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,aAAa;IACb;QACI,sBAAsB;QACtB,oBAAoB;QACpB;IACJ;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB;QACI,WAAW;QACX,cAAc;IAClB;EACF;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,uCAAuC;IACvC;QACI,iBAAiB;IACrB;EACF;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;QACI,kBAAkB;IACtB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB;IACA;IACA;AACJ;;AAEA;IACI,uBAAuB;IACvB;oEACgE;IAChE,uCAAuC;IACvC,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;QACI,eAAe;IACnB;IACA,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;;AAGA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;wBACoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;wBACoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC;IACE;EACF;AACF;;AAEA;EACE,uBAAuB;EACvB;gEAC8D;IAC5D,uCAAuC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B;IACE;EACF;AACF;;;AAGA;EACE,uBAAuB;EACvB;gEAC8D;EAC9D,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB;IACE;EACF;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB;gEAC8D;IAC5D,uCAAuC;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB;IACE;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;IACE;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;;AAEX;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB;IACE,mBAAmB;EACrB;EACA,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;IACE,mBAAmB;EACrB;EACA,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB;gEAC8D;IAC5D,uCAAuC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;gEAC8D;EAC9D,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,uBAAuB;EACvB;gEAC8D;EAC9D,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC;sBACoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB;cACY;AACd;;AAEA;EACE,uBAAuB;EACvB;kEACgE;EAChE,uCAAuC;EACvC,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB;MACI,eAAe;EACnB;EACA,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;cACY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB;cACY;IACV,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB;IACE,mBAAmB;EACrB;EACA,yCAAyC;AAC3C;;AAEA;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT;IACE;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;cACY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;cACY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB;cACY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;;EAErB;6BAC2B;AAC7B;AACA;EACE;oCACkC;EAClC,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;;EAEf,YAAY;;EAEZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".applyScreen {\n  border-radius: 20.188px;\n  box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);\n  background-color: var(--Primary, #e7ecef);\n  display: flex;\n  flex-direction: column;\n  min-width: 100%;\n  min-height: 100%;\n}\n\n.applyContainer {\n  align-self: center;\n  margin-top: 26px;\n  margin-bottom: 108px;\n  width: 100%;\n  @media (max-width: 991px) {\n    max-width: 100%;\n  }\n}\n\n.applyContent {\n  gap: 20px;\n  display: flex;\n  min-height: 100%;\n  justify-content: flex-start;\n}\n\n.applyDashboardContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 81%;\n  margin-left: 0px;\n  @media (max-width: 991px) {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n  \n  .applyDashboardContent {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    width: 700px;\n    margin-left: 10%;\n    @media (max-width: 991px) {\n      max-width: 100%;\n      margin-top: 20px;\n    }\n  }\n  \n\n  .applyCard{\n    border-radius: 16.842px;\n    box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n    align-self: stretch;\n    display: flex;\n    margin-top: 30px;\n    flex-grow: 1;\n    flex-direction: column;\n    @media (max-width: 991px) {\n    maxWidth: 100%;\n        marginRight: 2px\n    };\n    padding: 47px 20px 145px;\n  }\n\n  .chooseAProduct{\n    color: #000;\n    font-family: Roboto, sans-serif;\n    font-size: 40px;\n    font-weight: 400;\n    align-self: center;\n    margin-left: -26 px;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        text-wrap: initial;\n    }\n  }\n\n  .applyCardContainer{\n    align-self: center;\n    width: 680px;\n    max-width: 100%;\n    @media (max-width: 991px) {\n        margin: \"40px 0 10px\",\n    };\n    margin: 43px 0 -29px;\n  }\n\n  .applyCardContent{\n    gap: 20 px;\n    display: flex;\n    @media (max-width: 991px) {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0px\n    }\n  }\n\n  .cardContent{\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 43%;\n    margin-left: 0px;\n    @media (max-width: 991px) {\n        width: 100%;\n        margin-left: 0;\n    }\n  }\n\n  .purchaseButton{\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    border: none;\n    background-color: var(--boxes, #F8F8FB);\n    @media (max-width: 991px) {\n        margin-top: 40 px;\n    }\n  }\n\n  .imgClass{\n    aspect-ratio: 1.42;\n    object-fit: cover;\n    object-position: center;\n    width: 220px;\n    overflow: hidden;\n    align-self: stretch;\n    justify-content: center;\n    margin-left: auto;\n  }\n\n  .purchase{\n    color: #000;\n    font-family: Roboto, sans-serif;\n    font-size: 40px;\n    font-weight: 400;\n    align-self: center;\n    margin-left: 14 px;\n    text-wrap: nowrap;\n    margin-left: 100px;\n    @media (max-width: 991px) {\n        text-wrap: initial;\n    }\n  }\n\n  .loanOfficer {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    height: 20%;\n    width: 25%;\n    margin-left: -25%;\n    @media (max-width: 991px) {\n    marginLeft: 0,\n    }\n}\n\n.loanOfficerCard {\n    border-radius: 16.842px;\n    box-shadow:\n        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n    display: flex;\n    flex-grow: 1;\n    width: 214px;\n    max-width: 50%;\n    flex-direction: column;\n    width: 100%;\n    margin: auto;\n    overflow: scroll;\n    @media (max-width: 991px) {\n        marginTop: 20px;\n    };\n    margin: auto;\n    padding: 22px 20px 69px\n}\n\n.loanOfficerCardContent {\n    align-self: center;\n    display: flex;\n    margin-left: -19px;\n    margin-bottom: 8px;\n    width: 256px;\n    max-width: 100%;\n    flex-direction: column;\n}\n\n.loanOfficerImg{\n    aspect-ratio: 1.05;\n    object-fit: cover;\n    object-position: center;\n    width: 138 px;\n    overflow: hidden;\n    border-radius: 50%;\n    align-self: center;\n    max-width: 100%;\n}\n\n.homeImg{\n    aspect-ratio: 1.05;\n    object-fit: cover;\n    object-position: center;\n    width: 138 px;\n    overflow: hidden;\n    border-radius: 50%;\n    align-self: center;\n    max-width: 100%;\n}\n\n.yourLoanOfficer {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 32px;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 9px\n}\n\n.loanOfficerInfo {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 25px;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 9px\n}\n\n.forgotPasswordLink {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 25px;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 25px\n}\n\n\n.yourLoanOfficer {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 20.122px;\n    font-weight: 700;\n    align-self: center;\n    margin-top: 5px;\n    text-wrap: nowrap;\n}\n\n.loanOfficerInfo {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 13.5px;\n    font-weight: 600;\n    align-self: start;\n    margin-left: 30px;\n    margin-top: 13px 0 100px -10px;\n    overflow: scroll;\n}\n\n.borrowerFormTitle {\n  color: #000;\n  align-self: start;\n  flex-grow: 1;\n  flex-basis: auto;\n  font: 400 30px Roboto, sans-serif ;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.coborrower {\n  color: #3E94A3;\n  font-feature-settings: clig off, liga off;\n  letter-spacing: -0.408px;\n  text-align: left;\n  align-self: start;\n  margin-top: 10px;\n  text-wrap: nowrap;\n  font: 600 16px/137.5% Poppins, sans-serif;\n  @media (max-width: 991px) {\n    textWrap: \"initial\",\n  };\n}\n\n.borrowerFormCard {\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  display: flex;\n  width: 707px;\n  height: 448px;\n  max-width: 100%;\n  flex-direction: column;\n  text-align: center;\n  padding: 13px 8px 13px 20px;\n  @media (max-width: 991px) {\n    marginBottom: \"40px\",\n  };\n}\n\n\n.borrowerFormCardTabs {\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  display: flex;\n  width: 707px;\n  height: 448px;\n  max-width: 100%;\n  flex-direction: column;\n  text-align: center;\n  margin-top: -20px;\n  padding: 13px 8px 13px 20px;\n  overflow: scroll;\n  @media (max-width: 991px) {\n    margin-bottom: \"40px\",\n  };\n}\n\n.borrowerFormCardTabsInvisible {\n  display: none;\n  visibility: hidden;\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  width: 707px;\n  height: 448px;\n  max-width: 100%;\n  flex-direction: column;\n  text-align: center;\n  margin-top: -20px;\n  padding: 13px 8px 13px 20px;\n  overflow: scroll;\n  @media (max-width: 991px) {\n    marginBottom: \"40px\",\n  };\n}\n\n.borrowerFormCardDiv{\n  align-self: center;\n  display: flex;\n  width: 707px;\n  height: 100%;\n  max-width: 95%;\n  flex-direction: column;\n  text-align: center;\n  overflow: scroll;\n  @media (max-width: 991px) {\n    margin-bottom: \"40px\",\n  };\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 700px;\n  margin-left: 70px;\n  margin-right: 50px;\n}\n\n.inputsContainer{\n  align-self: start;\n  display: flex;\n  width: 635px;\n  max-width: 100;\n  align-items: flex-start;\n  gap: 13px;\n  @media (max-width: 991px) {\n    flexWrap: \"wrap\",\n  };\n}\n\n.declarationsDiv{\n  width: 300px;\n  margin-left: 5px;\n  margin-right: auto;\n  text-align: left;\n}\n\n.signInInput {\n  padding: 10px;\n  font-size: 12px;\n  border-width: 1px;\n  border-color: hsl(0, 0%, 64%);\n  background-color: #ffffff;\n  color: #a6a6a6;\n  border-style: solid;\n  border-radius: 35px;\n  display: flex;\n  width: 100%;\n  height: 15px;\n  padding-left: 20px;\n  padding-right: 60px;\n}\n\n.formInput {\n  padding: 10px;\n  font-size: 12px;\n  border-width: 1px;\n  border-color: #b1b1b1;\n  background-color: #ffffff;\n  color: #000000;\n  border-style: solid;\n  border-radius: 35px;\n  display: flex;\n  width: 100%;\n  height: 15px;\n  padding-left: 20px;\n  padding-right: 60px;\n}\n\n.formInputEthnicity {\n  padding: 10px;\n  font-size: 12px;\n  border-width: 1px;\n  border-color: #b1b1b1;\n  background-color: #ffffff;\n  color: #000000;\n  border-style: solid;\n  border-radius: 35px;\n  display: flex;\n  width: 100%;\n  height: 5px;\n  padding-left: 20px;\n  padding-right: 60px;\n}\n\n.inputDiv {\n  width: 300px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.inputDivEthnicity {\n  width: 130px;\n  margin-top: 5;\n  margin-bottom: 5;\n  margin-left: 25px;\n  display: flex;\n}\n\n.yearsAtAddressDiv{\n  width: 300px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: flex;\n}\n\n.ownerRadioButtons {\n  margin-top: 10px;\n  margin-left: 10px;\n  display: inline-block;\n  text-align: left;\n}\n\n.title {\n  text-align: center;\n}\n\n.borrowerFormCardTitleText {\n  align-self: end;\n  width: 603px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n  gap: 20px;\n \n}\n\n.coborrowerRadioContainer {\n  color: #000;\n  font-feature-settings: clig off liga off;\n  align-self: end;\n  margin-left: 10px;\n  text-wrap: nowrap;\n  text-align: left;\n  @media (max-width: 991px) {\n    textWrap: \"initial\";\n  };\n  font: 400 16px/137.5% Poppins, sans-serif;\n}\n\n.coborrowerRadioHispanic {\n  color: #000;\n  font-feature-settings: clig off liga off;\n  align-self: end;\n  margin-left: 30px;\n  text-wrap: nowrap;\n  text-align: left;\n  font-size: 10px;\n  @media (max-width: 991px) {\n    textWrap: \"initial\";\n  };\n  font: 400 16px/137.5% Poppins, sans-serif;\n}\n\n.coborrowerRadio label{\n  opacity: .4;\n}\n\n.coborrowerRadio input[type=radio]{\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  width: .9em;\n  height: .9em;\n  border: 0.15em solid currentColor;\n  border-radius: 50%;\n  border-color: #3E94A3;\n  margin-right: 5px;\n  transform: translateY(0.075em);\n  margin-left: 10px;\n}\n\n.coborrowerRadio input[type=radio]:checked{\n  background-color: #3E94A3;\n}\n\n.nextButtonDiv{\n  margin-left: auto;\n  margin-right: 5 px;\n}\n\n.nextButtonWithRadiosDiv{\n  display: flex;\n  margin-left: 15px;\n  margin-top: 10px;\n}\n\n.addressRadio{\n  margin-right: 10px;\n}\n\n.nextButton{\n  background-color: #3E94A3;\n  font-size: 16px;\n  width: 100px;\n  height: 35px;\n  border-radius: 17px;\n  font-weight: 300;\n  color: #ffffff;\n  border-color: #3E94A3;\n  margin-top: 20px;\n  margin-right: 10px;\n  margin-bottom: 3.5px;\n  border-style: none;\n}\n\n.newIncomeButton{\n  background-color: #3E94A3;\n  font-size: 16px;\n  width: 300px;\n  height: 35px;\n  border-radius: 17px;\n  font-weight: 300;\n  color: #ffffff;\n  border-color: #3E94A3;\n  margin-top: 20px;\n  margin-right: 10px;\n  margin-bottom: 3.5px;\n  border-style: none;\n}\n\n.backButton{\n  background-color: #ffffff;\n  font-size: 16px;\n  color: #3E94A3;\n  width: 100px;\n  height: 35px;\n  border-radius: 17px;\n  font-weight: 300;\n  cursor: pointer;\n  margin-top: 20px;\n  margin-right: 10px;\n  margin-bottom: 3.5px;\n  border-color: #3E94A3;\n}\n\n.myLoanerContainer {\n  display: flex;\n  flex-direction: column;\n  width: 20px;\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  display: flex;\n  width: 350px;\n  height: 570px;\n  max-width: 100%;\n  text-align: center;\n  margin-right: 10px;\n  margin-top: -20px;\n}\n\n.myLoanerContent {\n  display: flex;\n  margin-top: 10px;\n  flex-direction: column;\n  align-self: center;\n  width: 230px;\n  font-size: 24px;\n  justify-content: center;\n}\n\n.rectangle {\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  display: flex;\n  margin-bottom: 59px;\n  width: 730px;\n  height: 35px;\n  flex-direction: column;\n  @media (max-width: 991px) {\n    maxWidth: \"100%\";\n    marginTop: \"40px\"\n  }\n}\n\n.rectangleTabs {\n  border-radius: 16.842px;\n  box-shadow:\n    0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #F8F8FB);\n  align-self: center;\n  display: flex;\n  width: 730px;\n  height: 35px;\n  margin-bottom: 10px;\n  flex-direction: column;\n  @media (max-width: 991px) {\n    maxWidth: \"100%\";\n    marginTop: \"40px\"\n  }\n}\n\n.coborrowerLink {\n  justify-content: left;\n  color: var(--half-secondary, #3E94A3);\n  font-family:\n      Lato, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  align-self: start;\n  margin-top: 25px;\n  text-decoration: none;\n}\n\n.addressRadioButtons{\n  margin-top: 20px;\n  display: inline-block;\n  text-align: left;\n}\n\n.borrowerPresentAddressDiv{\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.useAddressDiv{\n  margin-top: 0px;\n  margin-bottom: 20px;\n}\n\n.dropdown {\n  padding: 10px;\n  font-size: 18px;\n  border-width: 1px;\n  border-color: #b1b1b1;\n  background-color: #ffffff;\n  color: #b1b1b1;\n  border-style: solid;\n  border-radius: 35px;\n  display: flex;\n  width: 100%;\n  height: 15px;\n  padding-left: 20px;\n  padding-right: 60px;\n}\n\n.selectBox{\n  width:100%;\n  height:100%;\n  border:0px;\n  outline:none;\n  color: #656565;\n}\n\n.label {\n  color: #000;\n  opacity: 40%;\n  text-align: left;\n  margin-left: 5px;\n  font-size: 15px;\n  margin-top: 10px;\n}\n\n.labelEthnicity {\n  color: #000;\n  opacity: 40%;\n  text-align: left;\n  margin-left: 5px;\n  font-size: 15px;\n}\n\n.jobLabel{\n  color: #000;\n  opacity: 40%;\n  text-align: left;\n  margin-left: 5px;\n  font-size: 15px;\n}\n\n.govtWarningDiv{\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  color: #656565;\n  margin-top: 75px;\n  margin-bottom: 93px;\n  font-size: 17px;\n}\n\n.creditScoreTextLabel {\n  width: 290px;\n  margin-top: 5px;\n  margin-left: -5px;\n  margin-left: 5px;\n  display: flex;\n}\n\n.zipCodeDiv{\n  display: flex;\n}\n\n.imgLogo {\n  aspect-ratio: 3.82;\n  object-fit: contain;\n  object-position: center;\n  width: 149px;\n  overflow: hidden;\n  align-self: start;\n  margin-top: 5px;\n  max-width: 100%;\n}\n\n.welcomeMessageDiv {\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.8;\n  align-self: start;\n  margin-top: 22px;\n  white-space: nowrap;\n  font: 600 16px/137.5% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n}\n\n.miniCard {\n  border-radius: 16.842px;\n  box-shadow:\n      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #ffffff);\n  display: flex;\n  flex-grow: 1;\n  width: 300px;\n  max-height: 30%;\n  flex-direction: column;\n  margin: auto;\n  overflow: scroll;\n  @media (max-width: 991px) {\n      marginTop: 20px;\n  };\n  margin: auto;\n  padding: 22px 20px 69px\n}\n\n.miniCardTitle {\n  position: relative;\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.8;\n  align-self: start;\n  white-space: nowrap;\n  font: 500 15px/169% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n}\n\n.miniCardText {\n  position: relative;\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.6;\n  align-self: start;\n  margin-top: 14px;\n  font: 400 13px/164% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n    text-align: left;\n}\n\n.miniCardRadio {\n  color: #000;\n  font-feature-settings: clig off liga off;\n  margin-top: 10px;\n  text-wrap: nowrap;\n  text-align: left;\n  @media (max-width: 991px) {\n    textWrap: \"initial\";\n  };\n  font: 400 16px/137.5% Poppins, sans-serif;\n}\n\n.miniCardRadio input[type=radio]{\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  width: .9em;\n  height: .9em;\n  border: 0.15em solid currentColor;\n  border-radius: 50%;\n  border-color: #3E94A3;\n  margin-right: 5px;\n  transform: translateY(0.075em);\n  margin-left: 10px;\n}\n\n.miniCardRadio input[type=radio]:checked{\n  background-color: #3E94A3;\n}\n\n.carButtonDiv{\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.cardButtonWithRadiosDiv{\n  display: flex;\n  margin-left: 15px;\n  margin-top: 10px;\n}\n\n.cardButton{\n  background-color: #3E94A3;\n  font-size: 16px;\n  width: 300px;\n  height: 35px;\n  border-radius: 17px;\n  font-weight: 900;\n  color: #ffffff;\n  border-color: #3E94A3;\n  margin-bottom: 10px;\n  border-style: none;\n}\n\n.miniCardContainer{\n  align-self: start;\n  display: flex;\n  width: 635px;\n  align-items: flex-start;\n  margin-top: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  gap: 20px;\n  @media (max-width: 991px) {\n    flexWrap: \"wrap\",\n  };\n}\n\n.miniCardTextDiv{\n  align-self: start;\n  display: flex;\n  width: 315px;\n}\n\n.infoCardTitle{\n  text-align: left;\n  position: relative;\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.8;\n  align-self: start;\n  white-space: nowrap;\n  font: 500 16px/169% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n  margin-bottom: -10px;\n}\n\n.infoCardTextLabel{\n  text-align: left;\n  position: relative;\n  color: #000000a7;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.8;\n  align-self: start;\n  white-space: nowrap;\n  font: 300 13px/169% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n}\n\n.infoCardText{\n  text-align: left;\n  position: relative;\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  opacity: 0.8;\n  align-self: start;\n  max-width: 100px;\n  white-space: nowrap;\n  font: 300 13px/169% Poppins, -apple-system, Roboto, Helvetica,\n    sans-serif;\n}\n\n.infoCardTextDiv {\n  width: 300px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.miniCardContainerSplit{\n  align-self: start;\n  display: flex;\n  width: 265px;\n  max-width: 100;\n  margin-bottom: -15px;\n  align-items: flex-start;\n  gap: 13px;\n  @media (max-width: 991px) {\n    flexWrap: \"wrap\",\n  };\n}\n\n.inputDivMiniCard {\n  width: 200px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.inputsContainerMiniCard{\n  align-self: start;\n  display: flex;\n  width: 250px;\n  max-width: 100;\n  align-items: flex-start;\n  gap: 13px;\n  @media (max-width: 991px) {\n    flexWrap: \"wrap\",\n  };\n}\n\n.inputsDivMiniCard {\n  width: 300px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: flex;\n}\n\n.tabs li { \n  /* Makes a horizontal row */\n  float: right; \n  list-style-type: none;\n  \n  /* So the psueudo elements can be\n     abs. positioned inside */\n}\n.tabs button { \n  /* Make them block level\n     and only as wide as they need */\n  float: left; \n  padding: 10px 40px; \n  text-decoration: none;\n  font-size: 15px;\n\n  width: 170px;\n  \n  /* Default colors */ \n  color: #fff;\n  background: #3E94A3;\n  /* Only round the top corners */\n  -webkit-border-top-left-radius: 15px;\n  -webkit-border-top-right-radius: 15px;\n  -moz-border-radius-topleft: 15px;\n  -moz-border-radius-topright: 15px;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 15px; \n  border: none;\n}\n.tabs .active {\n  /* Highest, active tab is on top */\n  z-index: 3;\n}\n.tabs .active button { \n  /* Colors when tab is active */\n  background-color: #fbfbfb; \n  color: black; \n}\n\n.errorDiv{\n  color: #3E94A3;\n  font-size: 15px;\n  margin-left: 10px;\n  margin-bottom: -16px;\n  margin-top: -1.5px;\n}\n\n.errorAndInputDiv{\n  text-align: left;\n}\n\n.uldiv {\n  align-items: center;\n}\n\n.uldiv li {\n  width: 525px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 1em;\n  background: #3E94A3;\n  position: relative;\n  color: white;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n\n.removeButton{\n  background-color: #ffffff;\n  font-size: 16px;\n  color: #3E94A3;\n  width: 75px;\n  height: 35px;\n  border-radius: 17px;\n  font-weight: 300;\n  cursor: pointer;\n  border-color: #3E94A3;\n  margin-left: auto;\n  margin-right: 5px;\n  border-style: none;\n}\n\n.incomeTypeText{\n  font-weight: 700;\n}\n\n.blankSpaceConfirmInfo li{\n  list-style: none;\n}\n.blankSpaceConfirmInfo {\n  text-align: left;\n}\n\n.blankSpaceConfirmInfo h2{\n  font: 300 20px Roboto, sans-serif ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"applyScreen": `ApplyForLoan_applyScreen__aic5S`,
	"applyContainer": `ApplyForLoan_applyContainer__dUaGT`,
	"applyContent": `ApplyForLoan_applyContent__JahEe`,
	"applyDashboardContainer": `ApplyForLoan_applyDashboardContainer__AIVef`,
	"applyDashboardContent": `ApplyForLoan_applyDashboardContent__Y-ias`,
	"applyCard": `ApplyForLoan_applyCard__heFAW`,
	"chooseAProduct": `ApplyForLoan_chooseAProduct__w3s7c`,
	"applyCardContainer": `ApplyForLoan_applyCardContainer__JkPYV`,
	"applyCardContent": `ApplyForLoan_applyCardContent__HvfY7`,
	"cardContent": `ApplyForLoan_cardContent__tEsY-`,
	"purchaseButton": `ApplyForLoan_purchaseButton__mbULy`,
	"imgClass": `ApplyForLoan_imgClass__esTlm`,
	"purchase": `ApplyForLoan_purchase__nC1+a`,
	"loanOfficer": `ApplyForLoan_loanOfficer__7x0Wp`,
	"loanOfficerCard": `ApplyForLoan_loanOfficerCard__yTwRZ`,
	"loanOfficerCardContent": `ApplyForLoan_loanOfficerCardContent__KB1w4`,
	"loanOfficerImg": `ApplyForLoan_loanOfficerImg__vHk20`,
	"homeImg": `ApplyForLoan_homeImg__5lZE0`,
	"yourLoanOfficer": `ApplyForLoan_yourLoanOfficer__HrUrX`,
	"loanOfficerInfo": `ApplyForLoan_loanOfficerInfo__022yZ`,
	"forgotPasswordLink": `ApplyForLoan_forgotPasswordLink__ZVzgX`,
	"borrowerFormTitle": `ApplyForLoan_borrowerFormTitle__Qn0Se`,
	"coborrower": `ApplyForLoan_coborrower__sOlg-`,
	"borrowerFormCard": `ApplyForLoan_borrowerFormCard__RiaAy`,
	"borrowerFormCardTabs": `ApplyForLoan_borrowerFormCardTabs__q2hDb`,
	"borrowerFormCardTabsInvisible": `ApplyForLoan_borrowerFormCardTabsInvisible__N9OjV`,
	"borrowerFormCardDiv": `ApplyForLoan_borrowerFormCardDiv__6rT6u`,
	"formContainer": `ApplyForLoan_formContainer__+Qhfu`,
	"inputsContainer": `ApplyForLoan_inputsContainer__8UugC`,
	"declarationsDiv": `ApplyForLoan_declarationsDiv__h1SzK`,
	"signInInput": `ApplyForLoan_signInInput__WLaOu`,
	"formInput": `ApplyForLoan_formInput__eTovx`,
	"formInputEthnicity": `ApplyForLoan_formInputEthnicity__AtE2K`,
	"inputDiv": `ApplyForLoan_inputDiv__vgHUN`,
	"inputDivEthnicity": `ApplyForLoan_inputDivEthnicity__w+ywx`,
	"yearsAtAddressDiv": `ApplyForLoan_yearsAtAddressDiv__cudQI`,
	"ownerRadioButtons": `ApplyForLoan_ownerRadioButtons__ZoknH`,
	"title": `ApplyForLoan_title__Vwz+X`,
	"borrowerFormCardTitleText": `ApplyForLoan_borrowerFormCardTitleText__-kMxt`,
	"coborrowerRadioContainer": `ApplyForLoan_coborrowerRadioContainer__K04gF`,
	"coborrowerRadioHispanic": `ApplyForLoan_coborrowerRadioHispanic__bcZ4K`,
	"coborrowerRadio": `ApplyForLoan_coborrowerRadio__Lr9UN`,
	"nextButtonDiv": `ApplyForLoan_nextButtonDiv__-kIxw`,
	"nextButtonWithRadiosDiv": `ApplyForLoan_nextButtonWithRadiosDiv__6EDPh`,
	"addressRadio": `ApplyForLoan_addressRadio__ZK3Kw`,
	"nextButton": `ApplyForLoan_nextButton__Cm8+Q`,
	"newIncomeButton": `ApplyForLoan_newIncomeButton__18aMA`,
	"backButton": `ApplyForLoan_backButton__oFSIl`,
	"myLoanerContainer": `ApplyForLoan_myLoanerContainer__lq0b+`,
	"myLoanerContent": `ApplyForLoan_myLoanerContent__YKo7N`,
	"rectangle": `ApplyForLoan_rectangle__PtKAH`,
	"rectangleTabs": `ApplyForLoan_rectangleTabs__4Zb8r`,
	"coborrowerLink": `ApplyForLoan_coborrowerLink__wKcjK`,
	"addressRadioButtons": `ApplyForLoan_addressRadioButtons__MYBni`,
	"borrowerPresentAddressDiv": `ApplyForLoan_borrowerPresentAddressDiv__FyajV`,
	"useAddressDiv": `ApplyForLoan_useAddressDiv__SAi7z`,
	"dropdown": `ApplyForLoan_dropdown__0xzk0`,
	"selectBox": `ApplyForLoan_selectBox__S40-V`,
	"label": `ApplyForLoan_label__K+i1n`,
	"labelEthnicity": `ApplyForLoan_labelEthnicity__gUUhv`,
	"jobLabel": `ApplyForLoan_jobLabel__HD8+r`,
	"govtWarningDiv": `ApplyForLoan_govtWarningDiv__BDXgq`,
	"creditScoreTextLabel": `ApplyForLoan_creditScoreTextLabel__UyAKU`,
	"zipCodeDiv": `ApplyForLoan_zipCodeDiv__p6XmR`,
	"imgLogo": `ApplyForLoan_imgLogo__mL71x`,
	"welcomeMessageDiv": `ApplyForLoan_welcomeMessageDiv__J3Ks2`,
	"miniCard": `ApplyForLoan_miniCard__RdLq6`,
	"miniCardTitle": `ApplyForLoan_miniCardTitle__86bai`,
	"miniCardText": `ApplyForLoan_miniCardText__Wc9jH`,
	"miniCardRadio": `ApplyForLoan_miniCardRadio__wDBQm`,
	"carButtonDiv": `ApplyForLoan_carButtonDiv__V4fOB`,
	"cardButtonWithRadiosDiv": `ApplyForLoan_cardButtonWithRadiosDiv__OcEpL`,
	"cardButton": `ApplyForLoan_cardButton__US+zk`,
	"miniCardContainer": `ApplyForLoan_miniCardContainer__YIG2k`,
	"miniCardTextDiv": `ApplyForLoan_miniCardTextDiv__kbp+y`,
	"infoCardTitle": `ApplyForLoan_infoCardTitle__SMJu9`,
	"infoCardTextLabel": `ApplyForLoan_infoCardTextLabel__qETU6`,
	"infoCardText": `ApplyForLoan_infoCardText__631UX`,
	"infoCardTextDiv": `ApplyForLoan_infoCardTextDiv__aa2WP`,
	"miniCardContainerSplit": `ApplyForLoan_miniCardContainerSplit__M9v8X`,
	"inputDivMiniCard": `ApplyForLoan_inputDivMiniCard__Zjx3c`,
	"inputsContainerMiniCard": `ApplyForLoan_inputsContainerMiniCard__mfsbl`,
	"inputsDivMiniCard": `ApplyForLoan_inputsDivMiniCard__qlbY0`,
	"tabs": `ApplyForLoan_tabs__t04AZ`,
	"active": `ApplyForLoan_active__doMEZ`,
	"errorDiv": `ApplyForLoan_errorDiv__jXBaR`,
	"errorAndInputDiv": `ApplyForLoan_errorAndInputDiv__YRI6R`,
	"uldiv": `ApplyForLoan_uldiv__ezReL`,
	"removeButton": `ApplyForLoan_removeButton__nDsuj`,
	"incomeTypeText": `ApplyForLoan_incomeTypeText__AgQxR`,
	"blankSpaceConfirmInfo": `ApplyForLoan_blankSpaceConfirmInfo__Mdp9G`
};
export default ___CSS_LOADER_EXPORT___;
